import React from 'react'
import { intl } from 'lang/intl'

import { TtTrayNote } from '@23/react'

import { type PropsWithTrayItemChildren } from '../TrayItem'
import { setTrayCardEditing, useTrayCardEditingId } from '../useTrayEditing'
import {
  setActiveCard,
  updateNoteCard,
  useTrayCard,
  useTrayCardState,
} from '../../../../firebase/hooks/useTray'

interface NoteCardProps {
  id: string
}

const NoteCard = ({
  id,
  children,
}: PropsWithTrayItemChildren<NoteCardProps>) => {
  const card = useTrayCard(id)
  const cardBeingEdited = useTrayCardEditingId()
  const cardState = useTrayCardState(id)

  const onCardClickHandler = () => {
    setActiveCard(id)
  }

  const onLabelChangeHandler = (value: string) => {
    updateNoteCard(id, value)
    setTrayCardEditing(null)
  }

  const isCurrentlyEditing = cardBeingEdited === id

  if (card?.type !== 'note') return null

  return (
    <TtTrayNote
      label={card.label}
      placeholder={intl.formatMessage({
        defaultMessage: 'Write your note',
      })}
      selected={cardState === 'active'}
      editing={isCurrentlyEditing}
      disabled={cardState === 'done'}
      onTt-click={(event) => {
        if (event.target === event.currentTarget) {
          onCardClickHandler()
        }
      }}
      onTt-change={(event) => {
        onLabelChangeHandler(event.detail.value)
      }}
    >
      {children?.({ canEdit: true })}
    </TtTrayNote>
  )
}

export default NoteCard
